/** Legal documents linked from the terms flow, in display order; the AI Disclaimer uses an in-app route. */
export const legalDocuments = ({ termsOfServiceLink, privacyPolicyLink, disclosureLink }) => [
  { label: 'Terms of Service', href: termsOfServiceLink },
  { label: 'Privacy Policy', href: privacyPolicyLink },
  { label: 'Disclosure Document', href: disclosureLink },
  { label: 'AI Disclaimer', to: '/ai-disclaimer' },
]
